import { Input } from '../../components/Input';
import { useCreateOperator } from '../../contexts/CreateOperatorContext';
import { SettingSectionHeader } from './Settings/SettingSectionHeader';
import { RequiredSettings } from './Settings/RequiredSettings';
import React from 'react';
import { ResidentialSystems } from './ResidentialSystems';

export const RequiredFields = () => {
  const classes = useStyles();
  const { onChange, operator } = useCreateOperator();
  const invalidId = operator.id !== 0 && operator.id.toString().length !== 6;
  const invalidCode =
    (operator.code !== '' && operator.code.trim().length < 4) ||
    operator.code.trim().length > 6;

  const defaultInputProps: any = {
    variant: 'contained',
    onChange: onChange,
    required: true,
  };

  return (
    <div className={classes.container}>
      <SettingSectionHeader
        className='pl-12 before:content-["*"] before:text-6xl before:absolute before:left-2'
        header="Minimum Requirements"
        description="These fields must be filled out to create an operator"
      />
      <fieldset className={classes.form}>
        <section className={classes.inline}>
          <Input
            className="w-1/5"
            name="id"
            error={invalidId}
            helperText={invalidId ? 'ID must be 6 digits' : undefined}
            label="Operator ID"
            value={isNaN(operator.id) ? '' : operator.id}
            type="number"
            {...defaultInputProps}
          />
          <Input
            className=""
            name="name"
            label="Operator Name"
            value={operator.name}
            {...defaultInputProps}
          />
          <Input
            className="w-1/6"
            name="code"
            label="Operator Code"
            error={invalidCode}
            helperText={invalidCode ? 'Must be 4-6 letters' : undefined}
            value={operator.code}
            {...defaultInputProps}
          />
        </section>
        <section className={classes.inline}>
          <Input
            className="w-2/5"
            name="timeZone"
            label="Timezone"
            value={operator.timeZone}
            {...defaultInputProps}
          />
          <ResidentialSystems />
        </section>
        <RequiredSettings />
      </fieldset>
    </div>
  );
};

const useStyles = () => ({
  container: 'flex flex-col',
  description: 'text-xs opacity-70',
  form: 'flex flex-col gap-4 p-4',
  group: 'inline-flex items-center gap-2',
  header: 'text-lg',
  sectionContainer: 'inline-flex items-start gap-4',
  sectionText: 'relative block px-2 py-4',
  inline: 'inline-flex flex-wrap items-center justify-start gap-6 w-full',
});
